import { useTranslation } from "react-i18next"
import { MIN_PASSWORD_LENGTH } from "../../../util/sizeUtils"
import * as yup from "yup"
import { translationKeys } from "../../../util/translationKeys"

export const useLoginSchemaProperties = () => {
  const { t } = useTranslation()
  const loginSchemaProperties = yup.object().shape({
    username: yup
      .string()
      .email(`${t(translationKeys.inputEmailErrorMessage)}`)
      .required(`${t(translationKeys.inputEmailNoInput)}`),
    password: yup
      .string()
      .min(
        MIN_PASSWORD_LENGTH,
        `${t(translationKeys.inputPasswordErrorMessage)}`
      )
      .required(`${t(translationKeys.inputPasswordNoInput)}`),
  })
  return loginSchemaProperties
}
